module.exports = __webpack_public_path__ + "static/media/libro6.1baa867b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/libro6.png
// module id = 354
// module chunks = 0